import React from "react";
import styles from "./Timeline.scss";
import { Icon } from "../../graphic/Icon";
import classNames from "classnames";
import moment from "moment";

export const Entry = ({ timestamp, label, children, icon, iconColor, color }) => {
    return (
        <div
            className={classNames(styles.entry, {
                [styles.iconDot]: !!icon,
                [styles.colorSuccess]: color === "success",
                [styles.colorWarning]: color === "warning",
                [styles.colorError]: color === "error",
                [styles.colorInfo]: color === "info",
                [styles.colorPrimary]: color === "primary",
                [styles.iconColorSuccess]: iconColor === "success",
                [styles.iconColorError]: iconColor === "error",
                [styles.iconColorPrimary]: iconColor === "primary"
            })}
        >
            <div className={styles.line} />
            <div className={styles.dot}>{icon && <Icon name={icon} />}</div>
            <div className={styles.content}>
                <div className={styles.header}>
                    {timestamp && <div className={styles.timestamp}>{moment(timestamp).format("lll")}</div>}
                    {label && <div className={styles.label}>{label}</div>}
                </div>
                {children}
            </div>
        </div>
    );
};
